import AuthGuard from "../auth/AuthGuard";
import NotFound from "../views/sessions/NotFound";
import pagesRoutes from "../views/pages/pagesRoutes";
import pageLayoutRoutes from "../views/settings/PageLayoutRoutees";
import { dashboardRoutes } from "../views/dashboard/DashboardRoutes";
import sessionRoutes from "../views/sessions/SessionRoutes";
import MatxLayout from '../components/MatxLayout/MatxLayout'



export const AllPages = () => {

  const all_routes = [
    {
      path: "/",
      element: (
        <AuthGuard>
          <MatxLayout />
        </AuthGuard>
      ),
      children: [
        ...dashboardRoutes,
        ...pageLayoutRoutes,
        ...pagesRoutes,
      ],
    },
    ...sessionRoutes,
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  return all_routes;
}
